// extracted by mini-css-extract-plugin
module.exports = {"statusInfoContainer":"status-info_statusInfoContainer__szf7w","text":"status-info_text__9GCUD","fade-in":"status-info_fade-in__yTiqV"};